import { getStripeLink } from '@/pages/api/scribeAPI';
import { toast } from '@heidi/design-system/toast';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

// paths
export const GET_STRIPE_LINK = `get_stripe_link`;

export function useQueryStripeLink(enabled = true) {
  return useQuery({
    queryKey: [GET_STRIPE_LINK],
    enabled: enabled,
    queryFn: async () => {
      try {
        const { data } = await getStripeLink();
        return data;
      } catch (error) {
        if (error instanceof AxiosError) {
          toast({
            tone: 'destructive',
            title: 'Error',
            description: JSON.stringify(error.response?.data),
          });
        }
        throw new Error();
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
